import { useState, useEffect, useContext } from "react";
import { ReactReduxContext } from "react-redux";
import isEmpty from "lodash/isEmpty";
import type { AuthenticationState } from "../interfaces/authentication.interface";

const useAuthentication = (): AuthenticationState | undefined => {
  const { store } = useContext(ReactReduxContext);

  const [state, setState] = useState<AuthenticationState>(
    store.getState().authentication as AuthenticationState
  );

  store.subscribe(() => {
    const { authentication }: { authentication: AuthenticationState } =
      store.getState();
    setState(authentication);
  });

  useEffect(() => {
    setState(store.getState().authentication);
    return store.subscribe(() => {
      setState(store.getState().authentication);
    });
  }, [store]);

  return !isEmpty(state) ? state : undefined;
};

export default useAuthentication;
